module.exports = __webpack_public_path__ + "static/media/plebiscito.c3e02f1f.jpg";